export default __webpack_public_path__ + "static/media/facebook-icon.89bf4bac.svg";